import {action, makeAutoObservable} from "mobx";
import {fetchUserBookRatings} from "../http/bookAPI";

export default class BookStore {
    constructor() {
        this._books = [];
        this._genres = [];
        this._assignments = [];
        this._assignmentsforthisbook = [];
        this._currentuserassigns = [];
        this._currentuserbooks = [];
        this._prices = [];
        this._languages = []; // Новое свойство для языков
        this._types = [];
        this._asstypes = [];// Новое свойство для типов задач
        this._bookratings = [];

        this._selectedBook = {};
        this._selectedGenre = {};
        this._selectedAssignment = {};
        this._selectedAssignmentForThisBook = {};
        this._selectedCurrentUserAssign = {};
        this._selectedCurrentUserBook = {};
        this._selectedPrice = {};
        this._selectedLanguage = {}; // Новый выбранный язык
        this._selectedBookType = {}; // Новый выбранный тип
        this._selectedAssType = {};
        this._selectedBookRating = {};

        this._page = 1;
        this._totalCount = 270;
        this._limit = 36;
        this._loading = false; // Для состояния загрузки
        this._sortassignments = false; // Для состояния сортировки

        makeAutoObservable(this, {
            setSortAssignments: action,
        });
    }

    // ======= Методы загрузки данных =======

    async loadUserBookRatings(userId) {
        try {
            const ratings = await fetchUserBookRatings(userId);
            this.setBookRatings(ratings); // ✅ Обновляем store после загрузки
        } catch (error) {
            console.error("Error fetching book ratings:", error);
        }
    }

    getBookRatingInfo(bookId) {
        return this._bookratings.find(rating => rating.bookId === bookId) || null;
    }


    // ======= Setters =======
   setLimit(limit) {
               this._limit = limit;
           }

   setLoading(val) {
              this._loading = val;
           }
    setPrices(prices) {
        this._prices = prices;
    }
    setBookRatings(bookratings) {
        this._bookratings = bookratings;
    }
    setSelectBookRating(bookrating) {
        this._selectedBookRating = bookrating;
    }
    setBooks(books) {
        this._books = books;
    }
    setGenres(genres) {
        this._genres = genres;
    }
    setAssignments(assignments) {
        this._assignments = assignments;
    }
    setAssignmentsForThisBook(assignmentsforthisbook) {
        this._assignmentsForThisBook = assignmentsforthisbook;
    }
    setCurrentUserAssigns(cua) {
        this._currentuserassigns = cua;
    }
    setCurrentUserBooks(cub) {
        this._currentuserbooks = cub;
    }
    setLanguages(languages) {
         this._languages = languages;
    }
    setTypes(types) {
        this._types = types;
    }
    setAssTypes(ass_types) {
       this._asstypes = ass_types;
    }
    setSelectedPrice(bprice) {
        this.setPage(1)
        this._selectedPrice = bprice;
    }
    setSelectedBook(book) {
        this._selectedBook = book;
    }
    setSelectedAssignmentForThisBook(assignmentforthisbook) {
        this._selectedAssignmentForThisBook = assignmentforthisbook;
    }

    setSelectedCurrentUserAssign(sscua) {
        this._selectedCurrentUserAssign = sscua;
    }
    setSelectedCurrentUserBook(sscub) {
        this._selectedCurrentUserBook = sscub;
    }
    setSelectedGenre(genre) {
        this.setPage(1)
        this._selectedGenre = genre;
    }
    setSelectedAssignment(assignment) {
        this._selectedAssignment = assignment;
    }
    setSelectedLanguage(language) {
        this.setPage(1)
        this._selectedLanguage = language;
    }
    setSelectedBookType(type) {
        this._selectedBookType = type;
    }
    setSelectedAssType(atype) {
        this.setPage(1)
        this._selectedAssType = atype;
    }
     setPage(page) {
        this._page = page;
    }
    setSortAssignments(value) {
        this._sortassignments = value;
    }
    setTotalCount(count) {
        this._totalCount = count;
    }

    // ======= Getters =======

    get bookratings() {
        return this._bookratings;
    }

    get selectedBookRating() {
        return this._selectedBookRating;
    }

    get prices() {
        return this._prices;
    }
    get books() {
        return this._books;
    }
    get genres() {
        return this._genres;
    }
    get assignments() {
        return this._assignments;
    }
    get assignmentsForThisBook() {
        return this._assignmentsforthisbook;
    }



    get currentuserassigns() {
        return this._currentuserassigns;
    }
    get currentuserbooks() {
        return this._currentuserbooks;
    }
    get selectedCurrentUserAssign() {
        return this._selectedCurrentUserAssign;
    }
    get selectedCurrentUserBook() {
        return this._selectedCurrentUserBook;
    }



    get languages() {
        return this._languages;
    }
    get types() {
        return this._types;
    }
    get asstypes() {
        return this._asstypes;
    }
    get users() {
        return this._users;
    }
    get selectedPrice() {
        return this._selectedPrice;
    }
    get selectedBook() {
        return this._selectedBook;
    }
    get selectedGenre() {
        return this._selectedGenre;
    }
    get selectedAssignment() {
        return this._selectedAssignment;
    }
    get selectedAssignmentForThisBook() {
        return this._selectedAssignmentForThisBook;
    }
    get selectedLanguage() {
        return this._selectedLanguage;
    }
    get selectedBookType() {
        return this._selectedBookType;
    }
    get selectedAssType() {
        return this._selectedAssType;
    }
    get totalCount() {
        return this._totalCount;
    }
    get page() {
        return this._page;
    }
    get limit() {
        return this._limit;
    }
    get loading() {
        return this._loading;
    }
    get sortassignments() {
        return this._sortassignments;
    }
}
